export default {
  activities: "Activities",
  home: "Home",
  version: "Version",
  save: "Save",
  edit: "Edit",
  new: "New",
  add: "Add",
  delete: "Delete",
  update: "Update",
  remove: "Remove",
  selected: "Select",
  clear_list: "Clear",
  change: "Change",
  description: "Description",
  remark: "Remark",
  related: "Related",
  attachments: "Attachments",
  bom_name: "BOM name",
  version_number: "Version number",
  actions: "Actions",
  associate: "Associate",
  date: "Date",
  taxed: "Taxed",
  title: "Title",
  quantity: "Quantity",
  pdf_download: "Download PDF",
  pdf_generate: "Generate PDF ",
  related_pdf: "Related PDF",
  amount: "Amount",
  currency: "Currency",
  is_tax_included: "Is tax included?",
  error: "Error",
  save_success_message: "Information has been saved successfully!",
  loading: "Loading...",
  currency_exchange_rate_tooltip: "The generic CNY vs USD conversion rate.",
  exchange_rate: "CNY-USD cross rate",
  non_tax: "Non-Tax",
  has_tax: "Taxed",
  logout: "Logout",
  links: "Links",
  open: "Open",
  complete: "Complete",
  completed: "Completed",
  categorize: "Categorize",
  male: "Male",
  female: "Female",
  unknown: "Unknown",
  go: "Go",
  created_at: "Created at",
  confirm: "Confirm",
  or: "or",
  select: "Select",
  type: "Type",
  option: "Option",
  not_available: "Not available",
  product_form: "Product profile",
  pricing_form: "Pricing properties",
  thumb: "Thumb",
  technical_data: "Technical data",
  confirm_delete_image_info: "Are you sure you want to delete this images？",
  product_info: "Product Information",
  product_desc:
    "The page shows the product information and all the related data.",
  product_list_desc:
    "Below shows all the products and semi unfinished products, you may use the search to quickly find what you are looking for.",
  bom_tool_desc1:
    "Using BOM tool helps creates the BOM belongs to a specific product or semi finished product.",
  bom_tool_desc2:
    "Changes to the BOM on this page will be stored in history and revisioned, so you can revert changes or pick a version for further quote or production.",
  new_quote_desc: "Generates a cost for the BOM.",
  bom_costs_desc: "Generates a cost for the BOM.",
  production_costs_desc:
    "Use the page to create a production costs for the product.",
  components_costs_desc:
    "This is a list of components used in a BOM, the costs entered here will be submitted to calculate a product's material costs.",
  my_profile_desc: "Preview or edit your profile.",
  unpublished: "Unpublished",
  published: "Published",
  view: "View",
  trade_type: {
    export: "Export",
    domestic: "Domestic"
  },
  empty_data: "No data",
  menu: {
    home: "Home",
    view: "View",
    edit: "Edit",
    project: {
      title: "Project",
      new_project: "New Project",
      project_list: "Project List",
      new_task: "New Task"
    },
    quote: {
      title: "Quote",
      quote_list: "Quotes",
      list_title: "Quotes",
      new_quote: "New Quote",
      edit_quote: "Edit Quote",
      cost_estimator: "Cost Estimator",
      overview: "Pricing Overview",
      price_quotation_page: "Preview Quotation",
      pdf_generate: "Create PDF",
      document: "Create PDF",
      estimate_quotes_group_list: "Estimates Groups",
      new_estimate_quotes_group: "New Estimate Group",
      priced_quotes_group_list: "Priced Quotes Groups",
      new_priced_quotes_group: "New Priced Quotes Group",
      edit_estimate_quotes_group: "Edit Estimate Group",
      edit_priced_quotes_group: "Edit Priced Group",
      margin_setting: {
        title: "Margin settings",
        historyTitle: "Margin setting history"
      },
      estimate_number: "Quote number",
      new_item: "Add line item",
      automatic_generated_item: "Try to populate items",
      switch_price: "Price switch",
      download_price_quotation: "Download",
      edit_price_quotation: "Edit Info",
      workflow: "Workflow",
      configure_workflow: "Workflow",
      tip: "Missing product or workflow",
      delete_tip: "Are you sure you want to delete this item?"
    },
    product: {
      title: "Products",
      new_product: "New Product",
      edit: "Edit Product",
      edit_product: "Edit Product",
      product_list: "Products"
    },
    bom: {
      title: "BOMs",
      edit_bom: "Edit BOM",
      bom_list: "BOMs",
      compositions: "Compositions",
      bom_history: "BOM History",
      part_overview: "Part Overview",
      part_usage: "Part Usage",
      part_number: "Part Number",
      part_migration_history: "Part Migration History",
      versions: "BOM Versions",
      upload: "Upload BOM",
      preview: "Preview imported BOM",
      review: "Review original BOM",
      upload_map: "Binding uploaded file data",
      look_bom: "View BOM"
    },
    part: {
      title: "Part overview",
      all: "All",
      list_page: {
        title: "Parts"
      },
      edit: {
        title: "Edit Part Information"
      },
      new: {
        title: "Create part"
      },
      compositions: "Compositions",
      part_overview: "Part Overview",
      part_usage: "Part Usage",
      part_migration_history: "Part Migration History"
    },
    pcb: {
      list_title: "PCB",
      edit: "Edit",
      new_pcb: "New"
    },
    electronic_part: {
      list_title: "Electronic Parts",
      edit: "Edit",
      new: "New"
    },
    mechanical_part: {
      list_title: "Mechanical Parts",
      edit: "Edit",
      new: "New"
    },
    assembled_part: {
      list_title: "PCBA, Semi-finished & Finished Parts",
      edit: "Edit",
      new: "New"
    },
    user: {
      title: "User",
      my_profile: "My Profile",
      my_tasks: "My Tasks"
    },
    purchasing: {
      title: "Purchasing",
      pricing: {
        components: "Component price"
      }
    },
    estimators: {
      title: "Cost Estimators",
      assembled_part_cost: "Assembled Part",
      assembled_part_cost_children: 'Materials',
      assembled_part_costed_bom: 'Cost Structure Analysis',
      pcb_cost: "PCB Cost",
      pcb: "PCB",
      pcb_specifications: "PCB Specifications",
      international_logistics: "International Logistic",
      supplier_component_prices: "Supplier Quote",
      purchased_parts_cost: 'Purchased Parts Cost'
    },
    companies: {
      title: "Companies",
      list: "Companies"
    },
    contact: {
      title: "Contacts",
      list: "Contacts",
      edit_contact: "Edit Contact",
      new: "New Contact"
    },
    account: {
      title: "Accounts",
      list: "Accounts",
      edit_account: 'Edit Account'
    },
    people: {
      list_title: "People",
      detail: "People Information",
      new: "New People",
      sync_people: "Sync from Dingtalk"
    },
    quality: {
      title: "Quality data",
      scrap: {
        title: "Scrap"
      }
    },
    message: {
      title: "Messages"
    },
    order: {
      list_title: "Orders",
      detail: "Order information",
      new: "New order"
    }
  },
  form: {
    name: "Name",
    chinese_name: "Name (Chinese)",
    email: "Email",
    title: "Title",
    role_at_pangu_website: "Role at Pangu website:",
    save: "Save",
    edit: "Edit",
    change: "Change",
    delete: "Delete",
    cancel: "Cancel",
    ok: "OK",
    note: 'Note',
    erp_id: "ERP ID",
    customer: "Customer",
    parent: "Parent",
    version_number: "Version Number",
    product: "Product",
    enter_product_name: "Enter Product Name",
    quantity: "Quantity",
    bom_version: "BOM Version",
    product_phase: "Product Phase",
    lead_time: "Lead Time",
    currency: "Preferred Currency",
    tax_rate: "Tax Rate (%)",
    comment: "Comment",
    log_message: "Log Message",
    bom_id: "BOM ID",
    parent_id: "Parent ID",
    part_number: "Part Number",
    description: "Description",
    mpn: "MPN",
    manufacturer: "Manufacturer",
    specification: "Specification",
    case_package: "Case Package",
    msl: "MSL",
    unit_name: "Unit",
    part_alias: "Part Alias",
    loss_rate: "Loss Rate (%)",
    line_quantity: "Line Qty",
    unit: "Unit",
    designator: "Designator",
    part_type: "Part Type",
    part: "Part",
    brand: "Brand",
    value: "Value",
    sync_mode: "Sync Mode",
    submit: "Submit",
    migrate_bom_to_erp: "Migrate BOM to ERP",
    bom_part_overview: "BOM Part Overview",
    assembly: "Assembly",
    is_assembled: "Assembled",
    return: "Return",
    select_bom_version: "Select BOM Version",
    select_version_source: "Select Version Source",
    item: "Item",
    cost: "Unit cost",
    qty: "Qty",
    amount: "Amount",
    tax: "Tax",
    summary: "Summary",
    scrap_amount: "Quality cost",
    bom: {
      name: "BOM Name",
      version: "Version",
      product: "Product",
      note: "Note",
      part_number: "Part Number",
      is_checked: "Is checked",
      part: "Part",
      setting: {
        load_global_mutual_substitutes: "Load global mutual substitutes",
        update_item_using_part_attributes: "Update item using part attributes",
        bom_type: "BOM type",
        use_octopart_as_source: "Use Octopart as source"
      }
    },
    quote_item: {
      title: "Title",
      item_type: "Type",
      assocated_model: "Associate",
      source: "Source",
      unit_cost: "Unit cost",
      note: "Note",
      quantity: "Quantity",
      volume: "Volume",
      margin_value: "Margin value",
      margin_percent: "Margin percent",
      tax_rate: "Tax rate",
      price_has_tax: "Price contains tax?",
      price: "Price",
      unit_price: "Unit price",
      margin: "Margin",
      reference: "Reference"
    },
    pcb_specifications: {
      board_name: "Board name",
      m_unit: "M. Unit",
      solider_mask: "Solider mask",
      legend_color: "Legend color",
      dimension: "Dimension",
      surface_finished: "Surface finished",
      layers: "Layers",
      copper_weight: "Copper weight",
      pcb_puzzle: "PCB puzzle",
      min_hole_sizes: "Min. Hole sizes",
      materials: "Materials",
      min_trance_space: "Min. Trace/Space",
      finished_thickness: "Finished thickness"
    }
  },

  /* The below entries are using feature namespace, so all the above shall be recreated in future */
  bom_tool: {
    info: {
      product_name: "Name",
      product_code: "Number",
      product_type: "Type",
      part_number_short: "PN",
      part_number: "Part Number",
      part_bom_name_alias: "Alias"
    },
    edit: {
      upload: {
        skip: "Skip",
        next: "Next",
        done: "Done",
        alreadyDone: "Already submitted",
        reupload: "Reupload",
        tip: "Click or drag files here to upload",
        download_template: "Download template",
        advenced: "Advenced options",
        header_row: "Header on line..."
      },
      map_col: {
        level: "Level",
        line_quantity: "Quantity",
        specification: "Specification",
        designator: "Designator",
        mpn: "MPN",
        chinese_name: "Name (Chinese)",
        name: "Name",
        brand: "Brand",
        case_package: "Case/Package",
        unit_name: "Unit",
        part_number: "NexPCB PN",
        type: "Type",
        preferred_status: "Preferred",
        notes: "Notes",
        editor_note: "Editor Note",
        row_index: "Row",
        title: "Select the column corresponding to the attribute",
        preview_title: "Preview the first 10 lines of uploaded file",
        note: "Note",
        part_alias: "Part name alias",
        version: "Version"
      },
      error: {
        empty: "No file uploaded yet",
        length: "No enough columns",
        return: "Please reupload"
      },
      history: {
        prev: "Undo",
        next: "Redo"
      },
      move: {
        move: "Move",
        modal_title: "Move in bulk",
        modal_input: "As children of (row#): "
      },
      edit_scrap_model_title: "Edit scrap in BOM",
      button_save_and_update_scrap: "Save and update the general material scrap",
      scrap: "Scrap (%)",
      note: "Note"
    },
    review: {
      actions: {
        export: "Export"
      },
      diff: {
        added: "Added",
        deleted: "Deleted",
        modified: "Modified",
        ignored: "Ignored"
      },
      version_select: "Version: "
    },
    assembled_bom: {
      version: "Version of assembled bom",
      view: "View assembled bom",
      customer_provided_tooltip: 'The material is supplied by customers'
    },
    migration: {
      pangu_bom: "EBOM",
      erp_boms: "MBOM on ERP",
      select_version: "Select version",
      notes: "Migration suggestion",
      current: "Current version",
      start_migration: "Start migration",
      start_migration_note:
        "Start migrate will create a new MBOM with specifcated versions for new Product number. Start or not?",
      erp_bom_is_reviewed: "Reviewed",
      erp_bom_version_matched_exist:
        "MBOM exist on ERP matched EBOM version, will not able to create a new MBOM by migration job. But you should make sure the MBOM on ERP is correct",
      erp_bom_exist_but_not_matched_version:
        "MBom exist on ERP but version not matched",
      erp_bom_exist_but_not_matched_version_option_1:
        "1. If no need to create a new MBOM on ERP, Please check componets, and update MBOM to same version",
      erp_bom_exist_but_not_matched_version_option_2:
        "2. Start migration job to create a new Product (Maybe XXXXX-X) and MBOM for this speficated version",
      create_new_bom_and_version:
        "You can start migration job to create MBOM for this version",
      parent_product: "Product",
      version: "Version",
      part_number: "Part number",
      name: "Name",
      erp_state: "ERP state",
      sync_state: "Sync state"
    },
    version: {
      version: "Version",
      compare_source: "Compare source",
      compare_version: "Compare version",
      button_compare: "Compare"
    },
    action_buttons: {
      review_changes_since_uploaded: "Review changes since uploaded",
      add_part: "Add a part",
      download_bom: "Download BOM",
      download_template: "Download BOM template",
      bom_navigator: "BOM navigator",
      upload_bom: "Upload BOM",
      edit_imported_bom: "Edit imported BOM",
      to_edit_bom: 'Edit BOM',
      to_compare_bom: 'BOM history'
    },
    version_number: "Version number",
    new_bom: "New BOM",
    delete_bom_confirm_dialog_title: "Delete confirmation",
    edit_bom_info: "Editing BOM information",
    delete_confirmation: "Are you sure you want to delete this BOM?",
    delete_bom_item_confirm: "Are you sure you want to delete this item?",
    synchronize_bom_to_erp: "Synchronize to ERP",
    synchronize_bom_to_erp_warning: "BOM is in editing, only versioned BOM can be synchronized.",
    synchronize_bom_to_erp_confim: "Confirm to synchronize BOM to ERP",
    new_version: "New version",
    bom_version_number_placeholder: "Enter such as 1.0.9.",
    log_message: "Log message",
    log_message_placeholder: "Enter a message describe what changes are made compared with last version.",
    create_new_version: "Create new version",
    current_version: "Current version",
    part_is_required: "Part is required.",
    load_parts_from_octopart: "Load parts from Octopart",
    export_bom: "Export BOM",
    revisions: "Revisions",
    release: "Release",
    add_part: "Add a part",
    alternatives: "Alternatives",
    more: "More",
    qty: "Qty",
    unit: "Unit",
    name: "Name",
    part_number: "Part number",
    specification: "Specification",
    mfr_part_number: "MPN",
    mfr_name: "Brand",
    designator: "Designator",
    status: "St.",
    actions: "Actions",
    manufacturer_part: "Manufacturer part",
    reference_manufacturer_part_link_title: "Click to view the referenced manufacturer part.",
    is_assembly: "Is assembly",
    item_name: "Item name",
    item_name_cn: "Item name (Chinese)",
    note: "Note",
    bom_item_form_drawer_title: "BOM item form",
    release_revision_and_log: "Revision number and release log",
    current_state: "Current state",
    editing: "Editing",
    versioned: "Released",
    latest_version: "Latest version",
    manufacturer_part_name: "Mfr. part name",
    created_at: "Created at",
    delete_item_confirmation_text: "Remove item confirmation!",
    suppliers: "Suppliers",
    quality_data: "Quality data",
    files: "Files",
    item_name_is_required: "Item name is required.",
    item_name_cn_is_required: "Item name (Chinese) is required.",
    specification_is_required: "Specification is requried.",
    line_quantity_is_required: "Quantity is required.",
    unit_name_is_required: "Measurement unit is required.",
    manufacturer_part_select_help: "Select a manufacturer part will automatically populate below properties.",
    bom_setting: "BOM Setting",
    engineer: "Engineer",
    name_is_required: "Name is required.",
    assembled_manufacturer_part_is_required: "Assembled manufacturer part is required.",
    engineer_is_required: "Engineer is required.",
    cost_estimation_using_purpose_bom_desc: "This BOM will only be used as cost estimation purpose.",
    engineering_bom: "Engineering BOM",
    cost_estimation_use: "Used for cost estimation",
    bom_type_is_required: "BOM type is required.",
    prosecutor_code_message: {
      BOM_ASSOCIATED_PART_HAS_NO_PART_NUMBER: "The BOM associated part has no part number.",
      BOM_ITEM_MISSING_ASSOCIATED_MANUFACTURER_PART: "The BOM item missing associated manufacturer part.",
      BOM_ITEMS_MISSING_PART_NUMBER: "The BOM has item associated parts missing Part Number.",
      BOM_ITEM_MODERATION_STATUS_DRAFT: "BOM item moderation state contains draft items.",
      BOM_HAS_NO_ITEMS: "The BOM has no items.",
      BOM_NOT_ASSOCIATED_WITH_PART: "The BOM has no associated manufacturer part.",
      BOM_CHILDREN_BOM_MISSING_VERSION: "Children BOM(s) missing version number.",
      BOM_ITEM_MISSING_PROPERTIES: "The BOM has items missing one or more required properties (name, specification, measurement unit and quantity).",
      BOM_ITEM_DESIGNATOR_QUANTITY_MISMATCH: "The BOM has items designator description and specified quantity are not matching.",
      ERP_CURRENT_BOM_VERSION_NOT_FOUND_BUT_FOUND_OTHER_RELATED_VERSIONS: "We have found other versions, but not this one.",
      ERP_BOM_VERSION_NOT_FOUND: "Current version or related not found in ERP.",
      ERP_BOM_VERSION_FOUND: "Current version already exists.",
      BOM_ITEM_MODERATION_STATUS_INVALID: "The BOM has item moderation status invalid."
    },
    add_alternate_part: "Add alternate part",
    show_similar_parts: "Show similar parts",
    preferred_status: "Preferred St.",
    preferred: "Preferred",
    alternate: "Alternate",
    manufacturer_part_number: "Mfr. part number",
    manufacturer_name: "Mfr. name",
    moderation_state: "Moderation state",
    lifecycle_status: "Lifecycle status",
    description: "Description",
    similar_parts_by_octopart: "Similar parts by Octopart",
    current_bom_only: "Current BOM only",
    global_substitute: "Global substitute",
    global_substitute_setting: "Global substitute setting",
    search_part: "Search part"
  },
  companies: {
    name: "Name",
    aliases: "Aliases",
    website: "Website",
    name_placeholder: "Enter company name",
    website_placeholder: "Enter company website",
    aliases_placeholder: "Press Enter to add an alias",
    add_alias: "Add",
    has_alias: "This alias is already added",
    tags: "Tags",
    search: "Search companies...",
    searching: "Searching...",
    no_result: "No result",
    new: "Add company",
    actions: "Actions",
    edit_company: "Edit company: ",
    add_company: "Add company",
    confirm_tip: "Confirm delete ",
    confirm_button: "Confirm",
    filter: {
      on: "Turn on filter",
      off: "Turn off filter"
    }
  },
  contact: {
    name: "Name",
    firstname: "Firstname",
    lastname: "Lastname",
    email: "Email",
    phone: "Phone",
    alias: "Alias",
    status: "Status",
    job_title: "Job title",
    description: "Description",
    address: "Street ddress",
    city: "City",
    state: "State",
    postal_code: "Postal code",
    country: "Country",
    firstname_placeholder: "Enter contact firstname",
    lastname_placeholder: "Enter contact lastname",
    email_placeholder: "Enter contact email",
    contact_phone_placeholder: "Enter contact phone number",
    alias_placeholder: "Enter contact alias",
    status_placeholder: "Select contact status",
    job_title_placeholder: "Enter contact's job title",
    description_placeholder: "Enter brief description about contact",
    address_placeholder: "Enter contact's street address",
    city_placeholder: "Enter contact's city",
    state_placeholder: "Enter contact's state",
    postal_code_placeholder: "Enter ontact's postal code",
    add_alias: "Add",
    has_alias: "This alias is already added",
    tags: "Tags",
    search: "Search contacts...",
    searching: "Searching...",
    no_result: "No result",
    new: "Add contact",
    actions: "Actions",
    edit_contact: "Edit contact",
    contact_form: "Contact details",
    add_contact: "Add contact",
    confirm_tip: "Confirm delete ",
    confirm_button: "Confirm",
    filter: {
      on: "Turn on filter",
      off: "Turn off filter"
    },
    status_select: {
      active: "Active",
      inactive: "Inactive"
    },
    load_contacts: "Load contacts",
    associated_company: {
      remove_modal: {
        title: "Dissociate Company from Contact",
        warning: "This contact will no longer be associated to this company.",
        confirm: "Do you want to proceed?",
        button_text: "Yes, Proceed"
      }
    },
    search_contact: {
      modal_title: "Load contacts from hubspot",
      search_placeholder: "Enter contact firstname for search ..."
    },
    info: {
      contact_created: "Contact saved successfully"
    }
  },
  part: {
    title: "Part",
    list: {
      title: "Electronic parts"
    },
    component_change_histories: "Component change histories",
    substitution: {
      type: "Type",
      mutually: "Mutually",
      unilateral: "Unilateral",
      L1:
        "Mutually, current part A can be alternative with part B, and B can be alternative with part A",
      L2:
        "Unilateral, current part B can be alternative with part A, but A is not alternative with part B"
    },
    info: {
      qc_properties: {
        need_examine: "Need Examine",
        default_examine_solution: "Examine Solution"
      },
      purchase_properties: {
        moq: "MOQ",
        mpq: "MPQ",
        english_name: "English Name",
        base_increase: "Base Increase",
        purchase_days: "Purchase before Days",
        standard_cost: "Standard Cost",
        major_supplier: "Major Supplier",
        unit: "Unit",
        is_taxed: "Is Taxed"
      },
      part_number: "Part number",
      english_name: "English Name",
      name: "Name",
      case_package: "Case/Package",
      chinese_name: "Chinese name",
      mpn: "Manufacturer part number (MPN)",
      brand: "Manufacturer name (Brand)",
      specification: "Specification",
      description: "Description",
      part_type: "Type",
      msl: "MSL",
      moderation: "Moderation",
      lifecycle_status: "Lifecycle status",
      lifecycle_status_standard: "Standard (most standard parts)",
      lifecycle_status_custom: "NSF (most custom parts)",
      require_quality_exam: {
        field_name: 'Requrie quality exam',
        yes: 'Yes',
        no: 'No'
      },
      unit: "unit",
      category: "Category",
      units: {
        pcs: "pcs",
        batch: "batch",
        unit: "unit",
        set: "set",
        suit: "suit",
        roll: "roll",
        kg: "kg"
      },
      ensure_part_is_reviewed_and_category_set: "Please ensure the part is reviewed and category is correctly selected."
    },
    specification_alert:
      "Specification will be generated automatically on saving specification form values below",
    similar_parts: "Similar Parts",
    alternatives: "Alternatives",
    spec_property_values: "Specification property values",
    similar_parts_empty_result: "No similar parts were found.",
    part_spec_add_fail_tip: "This specification is exist!!!",
    part_spec_add_success_tip: "Added successful!!!",
    part_spec_save_tip: "Saved successful！",
    search_placeholder: "Search part by part number or MPN",
    customer_information: "Customer provided",
    mutual_substitute: "Mutual substitute",
    unilateral_substitute: "Unilateral substitute",
    substitute_manage: "Manage",
    part_search_input_placeholder: "Enter part number, name, specification or MPN to search...",
    merge_mututal_substitute_collections_confirm: "Overlapped mutual substitute collection found, merge?",
    merge: "Merge!",
    substitute_collections_merged_success: "The merge has been done!",
    manage_part_substitutes: "Manage part substitutes",
    assembled_part: "Assembled part"
  },
  part_number_form: {
    generate_part_number_btn: "Generate part number",
    save_part_number_btn: "Save part number",
    remove_part_number_btn: "Remove part number",
    click_enter_pn_help_text: "Click me to enter a part number",
    concat_text_or: "or",
    cancel_btn: "Cancel",
    enter_part_number: "Enter a part number to create or change...",
    remove_confirm_message: "Are you sure to remove the part number?",
    enter_new_part_number_and_save: "Enter new part number and click save to continue.",
    part_moderation_status_is_not_reviewed: "Part moderation status must be reviewed."
  },
  quote: {
    info: {
      title: "Title",
      quote_number: "Quote number",
      quantity: "Quantity",
      product: "Product",
      product_bom_version: "BOM version",
      product_type: "Product type",
      customer: "Customer",
      lead_time: "Lead time",
      expected_delivery_date: "Expected delivery date",
      product_phase: "Phase",
      nsf_phase: "NSF stage",
      process_order_category: "Process/Order Category",
      preferred_currency: "Preferred currency",
      currency: "Currency",
      tax_rate: "Tax rate",
      exchange_rate: "USD-CNY",
      comment: "Comment",
      method: "Method",
      amount: "Amount",
      deal_link: "Deal link",
      deal_stage: "Deal stage",
      deal_type: "Deal type",
      urgency: "Urgent",
      reorder: "Reorder?",
      owner: "Owner",
      tech_info_received: "Tech info received of request",
      type: "Type",
      remark: "Remark",
      status: "Status",
      is_taxed: "Taxed or not",
      created: "Created",
      tip:
        "Please do not input quantity in title! Use the same title for quotes with different quantity will be grouped together.",
      missing_quote_number: "Missing quote number!",
      quote_cloned_success: "Quote has been cloned successfully!",
      quote_updated_success: "Quote has been updated successfully!",
      cost_estimator_created: "Cost estimation has been created!",
      about_simple_quote_method: "Prototyping quote, please refer to this message.",
      trade_type: "Trade type",
      is_tax_included: "Tax included",
      unit_cost: "Unit cost",
      unit_price: "Unit price",
      margin: "Margin",
      subtotal: "Subtotal",
      price_tax_excluded: "Price (No tax)",
      total_tax: "Total tax",
      product_name: "Product",
      product_field_help_desc: "Click to go to product page.",
      expires_date: "Expires date",
      payment_term: "Payment term",
      payment_term_note: "Payment term note",
      expecting_completion_date: "Expecting completion date",
      basecamp_todo_link: "Basecamp Todo Url"
    },
    status: {
      open: "Open",
      sent: "Sent",
      won: "Closed (Won)",
      lost: "Closed (Lost)",
      invalid: "Invalid",
      closed: "Closed"
    },
    types: {
      single_product: "Single Product",
      components: "Components",
      service: "Service",
      order_change: "Order change"
    },
    methods: {
      simple: "Simple",
      normal: "Normal",
      estimate: "Estimate",
      priced: "Priced",
      simple_option_desc: "Formal but without soft cost.",
      normal_option_desc: "Formal and with detailed hard and soft cost.",
      estimate_option_desc: "Pricing is less acurate, cannot be used as agreement.",
      priced_option_desc: "Formal and with certain pricing is less variable, such as, NSF S4 or above."
    },
    prices: {
      tax_include: "Price contains tax",
      tax_exclude: "Price without tax"
    },
    tabs: {
      items: "Items"
    },
    margin_setting: {
      quote_info: "Quote information",
      price: "Price",
      total: "Total",
      unit_price: "Unit price",
      gross_profit: "Margin",
      net_profit: "Net profit",
      total_cost: "Total cost",
      total_cost_all: "Total cost (tax included)",
      tax: "Tax",
      overall_margin: "Overall margin",
      overall_margin_2: "Overall margin tax in cost",
      test_margin_setting: "Margin setting",
      margin_setting_breakdown: "Margin setting breakdown",
      table_col_category: "Category",
      table_col_subcategory: "Sub category",
      table_col_margin_percent: "Margin %",
      table_col_margin: "Margin",
      table_col_price: "Price",
      table_col_unit_price: "Unit price taxed",
      table_col_unit_price_taxed: "Unit price non-taxed",
      table_col_sale_tax: "Sale tax",
      table_col_unit_cost: "Unit cost",
      table_col_unit_cost_taxed: "Unit cost (taxed)",
      table_col_remark: "Remark",
      table_col_cost: "Cost",
      table_time: "Time",
      table_total: "Total",
      table_user: "User",
      table_action: "Action",
      cost_breakdown: "Costs breakdown",
      additional_expenses: "Additional expenses",
      cost_breakdown_summary_expenses:
        "Costs breakdown summary & additional expenses",
      other_expenses: "Other expenses",
      expenses: {
        qc_cost: "QC cost",
        company_expenses: "Company expenses"
      },
      summary_total_cost_help:
        "Overall backend cost estimates WITHOUT tax, additional quality costs and company expenses.",
      summary_gross_profit_help:
        "Margin equals the total cost times overall margin.",
      summary_other_expense_help:
        "Other expenses includes quality cost and company expenses.",
      summary_tax_help: "The tax is extracted from the backend estiamted cost.",
      currencyTitle: "Currency select",
      history: "Look history",
      historyTitle: "Select time"
    },
    widgets: {
      details_link: "Details",
      date: "Date",
      lead_time: "Lead time",
      expected_delivery_date: "Expected delivery date",
      total_cost: "Total cost",
      quantity: "Qty",
      cost_estimation_title: "Cost estimation",
      create_cost_estimation: "Create cost",
      re_create_cost_estimation: "Create cost estimation",
      margin_setting: "Margin setting",
      overall_margin: "Overall margin",
      qc_cost: "QC cost",
      unit_cost: "Unit cost",
      company_expenses: "Company Exp.",
      discount: "Discount",
      amount: "Amount",
      create_margin_setting: "Create margin setting",
      related_quotes: "Related quotes",
      create_a_quote_form_this_one: "Duplicate",
      select_cost_estimator: "Select an existing cost estimator",
      find_cost_estimator_title: "Find cost estimator",
      unit_price: "Unit price (Taxed)",
      quote_activities_timeline: {
        title: "Quote activities timeline",
        display_toggle_btn_text_more: "Show more",
        display_toggle_btn_text_less: "Show less",
        cost_estimate_submits: {
          description: "Submitted cost {note} on {name}",
          materials: "Purchase components",
          sales_activities: "Sales",
          pm_activities: "PM",
          qc_activities: "QC",
          ee_activities: "EE",
          me_activities: "ME",
          assembly_activities: "Assembly",
          warehouse_activities: "Warehouse",
          scm_activities: "SCM",
          logistics_activities: "Logistics"
        },
        state_workflow: {
          description: "Workflow state changed from {from} to {to}",
          created: "Created",
          pending_cost_submissions: "Pending cost submissions",
          cost_submitted: "Cost submitted",
          cost_estimate_pending_approval: "Cost estimate approval",
          cost_estimate_submitted: "Cost estimate submitted",
          closed: "Closed",
          pending_cost_approval: "Pending cost approval",
          pending_margin_submission: "Pending margin submission",
          margin_review: "Margin review"
        }
      }
    },
    items: {
      sync_to_hubspot: "Send items to HubSpot",
      new_item: "Add line item"
    },
    search_from_title_placeholder: "Search from title",
    search_quote_number_placeholder: "Search quote number",
    search_quote_method_placeholder: "Search quote method",
    search_customer_placeholder: "Search customer",
    search_people_placeholder: "Search people",
    find_people_placeholder: "Enter people information",
    select_quote_method: "Select quote method",
    select_quote_status: "Select quote status",
    search_go: "Go",
    reopen: "Reopen",
    title_is_required: "Title is required.",
    method_is_required: "Method is required.",
    owner_is_required: "Owner is required.",
    trade_type_is_required: "Trade type is required.",
    nsf_phase_is_required: "NSF is required.",
    process_order_category_is_required: "Process/Order Category is required.",
    click_open_hubspot_quote_page: "Click here to open HubSpot quote page.",
    create_order_from_quote: "Create order",
    status_is_required: "Status is requierd.",
    expires_date_is_required: "Expires date is requierd.",
    customer_is_required: "Customer is requierd.",
    currency_is_required: "Currency is requierd.",
    type_is_required: "Type is requierd.",
    enter_price_with_tax_desc: "Price with tax",
    creating_order_on_quote_not_won_error: "Cannot create order when quote's status is not closed with won.",
    create_estimate_pdf: "Create Estimate PDF",
    group_status_activated: "Activiated",
    group_status_invalidated: "Invalidated",
    group_status_drafting: "Drafting",
    group_status_closed: "Closed",
    quantity_is_required: "Quantity is required.",
    exchange_rate_is_required: "Exchange rate is required.",
    quote_created_success_message: "Quote has been created successfully !",
    list_is_empty: "List is empty.",
    cost_estimator_missing_manufacturer_part_error: "Please ensure the manufacturer part is associated with the quote in technical data section.",
    select_manufacturer_part_bom: "Select BOM",
    bom_is_required: "BOM is required.",
    item_type_referenced_type: "Select type",
    item_type_ref_product: "Product",
    item_type_ref_manufacturer_part: "Manufacturer part",
    item_type_ref_fee: "Fee",
    sync_hubspot: "Create or update HubSpot quote",
    link_to_deal: "Link to deal",
    back_to_quote_page: "Back to quote page",
    hubspot_deal_using_different_currency_message: "The deal is using a different currency: %s. Forgot to change in Hubspot?",
    show_more_hubspot_quote_template: "Show more",
    select_quote_type_placeholder: "Select quote type",
    item_prevent_editing_parent_associated: "You may only edit the price and keep the rest as it is, since it is being associated with a another item.",
    creating_order_missing_items: "Order missing items, you may not create hubspot quotation or order from this quote.",
    expecting_completion_date_is_required: "Expecting completion is required.",
    basecamp_todo_link_desc: "Adding a basecamp todo's link to automatically send updates to basecamp.",
    basecamp_todo_link_not_correct: "Bascamp todo link not match the format"
  },
  order: {
    order_info_head: "Order information",
    title: "Title",
    search_go: "Go",
    order_number_length_exceeded: "Order number length exceeded.",
    short_description_is_required: "Short description is required.",
    product_phase_is_required: "Product phase is required.",
    nsf_phase_is_required: "NSF is required.",
    process_order_category_is_required: "Process/Order Category is required.",
    order_type_is_required: "Order type is required.",
    product_type_is_required: 'Product type is required',
    enter_order_number_desc: "Enter order number",
    search_customer_desc: "Enter customer information",
    search_accounting_belongs: "Select accounting belongs",
    new_order: "New order",
    quote_reference: "Quote reference",
    quote_reference_desc: "Click here to view the quote.",
    short_description: "Short description",
    short_description_desc: "ERP requires a short description no longer than 50 characters.",
    order_number: "Order number (SO)",
    domestic_export_type: "Domestic/Export",
    domestic_export_type_domestic: "Domestic order",
    domestic_export_type_export: "Export order",
    customer_order_number: "Customer order number (PO)",
    customer: "Customer",
    order_date: "Order date",
    created_date: "Created date",
    order_status: "Order status",
    order_type: "Order type",
    order_type_select_placeholder: "Select order type",
    product_stage: "Product stage",
    nsf_phase: "NSF stage",
    product_stage_select_placeholder: "Select a product stage",
    nsf_phase_select_placeholder: 'Select a NSF stage',
    process_order_category_select_placeholder: 'Select a Process/Order category',
    product_type: "Product type",
    product_type_select_placeholder: "Select a product type",
    shipping_address: "Shipping address",
    accounting_belongs: "Accounting belongs",
    currency: "Currency",
    exchange_rate: "Exchange rate",
    sales_person: "Sales person",
    remark: "Remark",
    order_items: "Order items",
    product_number: "Product number",
    product: "Product",
    quantity: "Qty",
    unit_cost: "Unit cost",
    unit_price: "Unit price",
    subtotal: "Subtotal",
    delivery_date: "Delivery date",
    delivery_date_is_required: "Delivery date is required.",
    actions: "Actions",
    total: "Total",
    add_item: "Add item",
    term: "Term",
    sale_style: "Sale style",
    sale_style_from_warehouse: "From warehouse",
    sale_style_from_3rdparty: "From third party",
    order_already_in_erp_msg: "It looks like the order has already been in ERP!",
    order_already_in_qbo_msg: 'The order has send to QBO as an Estimate.',
    order_item_form: "Order item form",
    send_order_to_erp: "Send order to ERP",
    send_order_to_qbo: "Update QuickBooks",
    address_field_not_yet_available: "The field is not yet available due to address related data problem.",
    bom_version: "BOM version",
    is_tax_included: "Is tax included",
    tax_rate: "Tax rate",
    manufacturer_part: "Manufacturer part",
    is_manufactured: "Is manufactured",
    margin: "Margin",
    missing_data_error: "Missing!",
    missing_part_or_version: "Missing manufacturer part or version!",
    total_tax: "Total tax",
    price_tax_excluded: "Unit Price",
    subtotal_tax_excluded: "Subtotal",
    customer_should_have_account_number: "Customer missing account number required.",
    order_validate_before_send_to_erp: "Please finish the order data, then try to migrate to ERP",
    created_by_person: "Created by",
    select_customer_message: "Please select a customer.",
    creator_missing_required_erp_id: "The creator missing required ERP user ID.",
    order_reason: "Order reason",
    order_reason_is_required: "Order reason is required.",
    no_ref: "No reference",
    quoted: "Quoted",
    reorder: "Reorder",
    description_is_required: "Description is required.",
    accounting_company_is_required: "Account belongs is required.",
    date_is_required: "Date is required.",
    owner_is_required: "Owner is required.",
    exchange_rate_is_required: "Exchange rate is required.",
    order_change_reasoning_is_required: "Change reasoning is required.",
    order_change_reasoning: "Change reasoning",
    engineering_craft: "Engineering & craft related",
    order_change_fees: "Fees",
    order_change_others: "Others",
    order_item_change: "Order items change",
    order_item_product_qty_change: "Product / accessories quantity changed",
    bom_changed: "BOM changed",
    design_changed: "Design changed",
    shipping: "Shipping",
    over_changed: "Over changed",
    exchange_rate_changed: "Exchange rate changed",
    tax: "Tax",
    delivery_date_changed: "Delivery date changed",
    service_agreement_changed: "Service agreement changed",
    change_reason_others: "Others",
    additional_fee_description: "Description",
    additional_fee_description_is_required: "Description is required.",
    invoice_number: "Invoice #",
    additional_fee_cost: "Cost",
    additional_fee_price: "Price",
    additional_fee_qty: "Quantity",
    add_order_change_fee: "Add order change fee",
    additional_order_change_items: "Items",
    order_change_modal_title: "Order change fee form",
    additional_fee: "Fee",
    currency_is_required: "Currency is required.",
    fee_design: "Design fee",
    fee_design_desc: "Extra design fee",
    fee_generic_service: "Generic service fee",
    fee_generic_service_desc: "Extra generic service fee.",
    fee_purchase_refund: "Purchase refund",
    fee_purchase_refund_desc: "Overchanged or purchase refund.",
    fee_tax: "Tax",
    fee_tax_desc: "Tax",
    fee_import_clearance: "Import clearance fee",
    fee_import_clearance_desc: "Extra import clearance fee.",
    fee_operation: "Operation fee",
    fee_operation_desc: "Extra operation fee",
    fee_extra_urgency: "Extra urgency fee",
    fee_extra_urgency_desc: "Extra fee for urgency request.",
    fee_labor: "Labor cost",
    fee_labor_desc: "Extra labor cost.",
    fee_shipping: "Shipping fee",
    fee_shipping_desc: "Extra shipping cost.",
    fee_bom_change: "BOM change fee",
    fee_bom_change_desc: "Extra fee charged for BOM change.",
    fee_storage: "Storage fee",
    fee_storage_desc: "Storage rental or management.",
    fee_fixture: "Fixture fee",
    fee_fixture_desc: "The extra fixture costed.",
    fee_exchange_rate_change: "Exchange rate change difference",
    fee_exchange_rate_change_desc: "Extra or refund due to exchange rate changed.",
    additional_fee_is_required: "Fee is required.",
    additional_fee_title_is_required: "Title is required.",
    additional_fee_qty_is_required: "Quantity is required.",
    additional_fee_price_is_required: "Price is requried.",
    additional_fee_add_item: "Add fee",
    additional_fee_total: "Total",
    order_change_reasoning_message: "Explain other reason",
    change_reasonning_message_is_required: "Please describe the reason.",
    order_item_changes: "Item changes",
    order_change_records: "Order change records",
    additional_fee_create_quote: "Create as quote",
    additional_fee_save_apply: "Save and apply to order",
    order_additional_fee_order_item_change_message: "This change requires to modify order items and shall be shipped out.",
    order_additional_fee_item_change_message: "This fee is added as decrease or increase to order, won't be shipped out.",
    manufacturer_part_is_required: "Part is required.",
    bom_version_is_required: "BOM version is required.",
    additional_fee_delivery_date_is_required: "Expected delivery date is required.",
    additional_fee_status: "Status",
    additional_fee_status_description: "Change and price approved will be synchronized to ERP and QB accordingly.",
    additional_fee_sync2erp: "Save changes to ERP",
    additional_fee_sync2qbo: "Save changes to Quickbooks",
    accumulated_amount: "Total amount",
    additional_fees: "Additional fees",
    fee_type: "Fee type",
    price: "Price",
    check_associated_quote: "Check associated quote",
    order_change_record_quote_created: "Quote created",
    order_change_date_is_required: "Order change date is required.",
    order_change_date: "Date",
    order_change_sub_order_number: "Sub order number",
    order_change_sub_order_number_desc: "Separate ERP order for this change.",
    open: "Open",
    closed: "Closed",
    invalid: "Invalid",
    address: "Address",
    pending_approval: "Pending approval",
    approved: "Approved",
    status: "Status",
    approval_status: "Approval status",
    prepays: "Prepays",
    change_status_open: "Open",
    change_status_approved: "Approved",
    change_status_invalided: "Invalid",
    item_remark: "Remark",
    item_remark_is_required: "Remark is required.",
    order_change_warning: "Sub order number provided with different SO number or non-fee type of items added will create new order.",
    order_save_success: "Order has been saved successfully."
  },
  cost: {
    summary: "Summary",
    currency: "Currency",
    delete_tip: "Remove this assembled part cost estimator?",
    new_assembled_part_cost_estimator: "New assembled part cost estimator",
    assembled_part_cost_estimator_info: "Assembled part cost estimator",
    manufacturer_part: "Manufacturer part",
    part_cost_form: {
      title: "Title",
      part: "Part",
      assembled_part: "Assembled part",
      bom: "BOM",
      product: "Product",
      bom_version: "BOM version",
      quantity: "Quantity",
      volume_requested: "Volumes",
      currency: "Currency",
      conversion_rate: "Rate",
      tax_rate: "Tax rate",
      no_bom_set:
        "No materials set for this estimator, you can set a bom to load materials",
      import_materials_from_excel: "Import materials from excel",
      export_materials_to_excel: "Export data to excel file",
      submit_estimates: "Submit estimates",
      load_octopart_components_prices: "Load Octopart components prices",
      load_erp_components_avg_costs: "Load ERP components average costs",
      quantity_change_tip:
        "Select another quantity for the quotes on the same group.",
      systemQuote: "System quote",
      std_cost_refresh: "Import standard cost",
      bom_draft_tip: "The sub BOM versions of the currently selected BOM are draft",
      bom_not_draft_tip: "The sub BOM version of the currently selected BOM is the version when setting BOM",
      bom_tip: "This product has no BOM, please create it",
      import_materials: "Load materials",
      back_to_cost_estimator_top_page: "Back to cost estimator top page"
    },
    materials: {
      manufacturer_part_id: "Part id",
      quantity: "Quantity",
      price: "Price",
      currency: "Currency",
      price_has_tax_or_not: "Taxed ?",
      price_has_tax: "Taxed",
      price_no_tax: "Not taxed",
      tax_rate: "Tax rate",
      avg_cost: "Avg cost (CNY)",
      standard_price: "Standard price (CNY)",
      change_log: "Change log",
      changed_by: "Changed By",
      changed_time: "Changed time",
      material_list_remove_confirm_title: "Clear materials confirmation",
      delete_confirm: "Remove this materials?",
      clear_list:
        "The operation will remove all the materials and their price information! Click OK to remove.",
      has_materials:
        "Materials list is existed, are you sure you want to upload",
      table_title_validate:
        "Import table title of Qty, MPN, Brand, Specification, Name, Price, Net qty and Taxed is must",
      quantity_placeholder: "Please enter your quantity",
      quantity_tip:
        "Set a quantity only when the BOM represents a single volume product.",
      table_item_id_validate:
        "Table item id is different, Please clear table list before upload",
      price_high_tooltip: "This price higher than standard cost",
      price_source_usd: "The price source is US dollars",
      material_not_found_tooltip: "Not found in the parts database",
      category: "Category",
      top_five: "Top5",
      total: "Total cost (non-tax)",
      net_cost_tip: 'Supplier cost or historical purchase standard price cost',
      risk_cost_tip: 'Engineer estimates risk cost',
      net_cost: "Net cost",
      quality_cost: "Quality cost",
      risk_cost: 'Risk cost',
      total_rate: 'Tax',
      grand_total: 'Grand total',
      bom_import_model_content: "This BOM has part not set scrap！",
      bom_import_model_to: "Go to edit",
      button_add_supplier: 'New supplier',
      full_screen: 'Full screen',
      add_model_title: 'New supplier price',
      price_adjustment: 'The price is adjusted modified',
      button_new_supplier_quote: 'New supplier price',
      assembled_part_cost_model_params_config_form: {
        title: {
          quote_strategy_setup: "quote_strategy_setup",
          data_source_configuration: "Data source configuration"
        },
        select: {
          customer_tier_select: "Select customer tier",
          preferred_suppliers: "Preferred suppliers"
        },
        check_box: {
          use_mpq: "Try using MPQ price as much as possible",
          enabled: "Enabled"
        },
        input: {
          purchase_histories: "Purchase histories",
          quote_created_date_limit: "Quotes created since",
          date_after: "months ago"
        },
        tips: {
          purchase_histories_tip: "Purchase will be retrieved since then",
          preferred_suppliers_tip:
            "select the preferred suppliers the components purchased from them",
          quote_created_tip: "Purchase will be retrieved since then"
        },
        sources: {
          octopart: "Octopart",
          erp: "Erp",
          rfq: "Quotes from offline suppliers",
          quotes: "Quotes"
        },
        buttons: {
          button_cancel: "Cancel",
          button_save_and_start_quoting: "Save and start quoting"
        },
        customer_tier_labels: {
          prefer_online_price: "Prefer online price",
          prefer_lowest_price: "Prefer lowest price",
          prefer_most_recent_purchase_qty:
            "Prefer recently purchased price of similar qty"
        }
      },
      displayNameInfoForm: {
        edit_title: "Materials info edit",
        new_title: "Add materials"
      },
      priceInfoForm: {
        std_price: "Std. buying price",
        std_cost: "Std. cost",
        avg_cost: "Avg. cost",
        mpq: "MPQ",
        last_purchased: "Last purchased",
        suggested_purchase_qty: "Suggested purchase qty",
        price: "Price",
        change_logs: "Change logs",
        tax_excluded: "Non-tax",
        price_table: "Price table",
        adjustment_reason: 'Adjustment reason',
        other_reason: 'Note',
        supplier: 'Supplier',
        quantity: 'Quantity',
        note: 'Note',
        reason: {
          customer_provided: 'Customer provided',
          engineer_risk_evaluation: 'Engineering reasons',
          market_price_increase: 'Market price increase',
          market_price_cut: 'Market price cut',
          other: 'Other'
        }
      },
      form: {
        cancel: "Cancel",
        save: "Save",
        net_quantity_tip: 'If the item exists in BOM, the net demand quantity in BOM will be used',
        quantity_tip: 'If the item exists in the BOM, the quantity in the BOM will be used'
      },
      purchased_parts_cost_title: 'Purchased Components Cost Estimator',
      stock_availablity_filter: {
        stock_empty: 'Stock empty',
        stock_available: 'Stock available',
        stock_greater_than_qty: 'Stock greater than qty'
      }
    },
    cost_summary: {
      total_cost: "Total cost",
      tax: "Tax",
      amount_taxed: "Amount(taxed)",
      unit_cost: "Unit cost",
      unit_cost_taxed: "Unit cost(taxed)",
      scrap_amount: "Quality cost"
    },
    pricing: {
      change_log: "Price change logs",
      category_setup: "Quote strategy setup",
      automatic_price: "System quote setup",
      success: "Price is successfully set for materials, please review.",
      start: "Save and start quoting",
      cancel: "Cancel",
      month_ago: "months ago",
      enabled: "Enabled",
      date_since: "Quotes created since",
      manage_sources: "Data source configuration",
      use_mpq_price: "Try using MPQ price as much as possible",
      select_customer_tier: "Customer tier",
      sources: {
        quote: {
          name: "Quotes"
        },
        erp: {
          name: "ERP",
          purchase_history: "Purchase histories",
          purchase_history_tooltip: "Purchase will be retrieved since then",
          supplier: "Preferred suppliers",
          supplier_select:
            "Select the preferred suppliers the components purchased from them",
          fallback_option: "When no purchase records matched, uses",
          fallback_option_help:
            "Select the fall back option when no proper purchase records matched.",
          standard_cost_over_avg_cost: "Uses standard cost over average cost",
          avg_cost_over_standard_cost: "Uses average cost over standard cost"
        },
        octopart: {
          name: "Octopart",
          supplier: "Preferred suppliers",
          supplier_select:
            "Select the preferred suppliers the components purchased from them"
        },
        rfq: {
          name: "Supplier inquiry",
          supplier: "Preferred suppliers",
          supplier_select:
            "Select the preferred suppliers the components purchased from them"
        }
      }
    },
    pcb_cost: {
      title: "PCB cost",
      edit_spec: "Edit PCB Specifications",
      currency_tip: "* The price uses CNY currency.",
      urgency_days_tip: "Before standard time",
      history_title: "Estimate Cost History",
      calculate_title: "Calculate",
      pcb_cost_form: {
        quantity: "Quantity",
        impedence_test: "Impedence test",
        service_fee: "Service fee",
        urgency_days: "Urgency days",
        details: "Details",
        standard_time: "Standard time",
        board_cost: "Board cost",
        express_fee: "Express fee",
        urgency_fee: "Urgency fee",
        calculated_price: "Calculated price",
        working_days: "working days"
      },
      button: {
        calculate: "Calculate",
        save: "Save",
        calculate_history: "View previously created PCB cost estimates"
      }
    },
    costed_bom: {
      purchased_parts_cost: 'Purchased parts cost',
      add_purchased_parts_cost: 'Purchased parts cost',
      soft_hard_cost: 'Proportion of soft and hard costs',
      total_cost_components: 'Total cost components',
      recurring: 'Recurring/Non-recurring',
      costed_bom_view: 'Costed BOM view',
      summary_view: 'Summary view',
      parts_form: {
        level: 'Level',
        name: 'Item description',
        line_quantity: 'Single qty',
        net_quantity: 'Net qty',
        total_quantity: 'Qty(scrap included)',
        unit_price: 'Unit cost',
        net_amount: 'Extended cost(net)',
        scrap_amount: 'Scrap cost',
        amount: 'Extended cost(scrap included)',
        action: 'Actions',
        tip: 'The item is not in BOM'
      }
    },
    reports: {
      backend_soft_cost: 'Soft cost',
      backend_hard_cost: 'Hard cost',
      backend_scrap_cost: 'Scrap cost',
      backend_engineering_cost: 'Engineering cost',
      backend_production_cost: 'Production cost',
      recurring_cost: 'Recurring cost',
      non_recurring_cost: 'Non-recurring cost',
      mechanical_part: 'Mechanical part',
      circuit_board: 'PCB',
      express_cost: 'Express cost',
      electronic_part: 'Electronic part',
      assembled_part: 'Assembled part'
    }
  },
  homepage: {
    aggregated_sum: {
      total_quotes_won: "Total Number of quotes won",
      total_amount_quoted: "Successful quoted amount",
      total_no_of_products: "All time total number of products",
      total_ordered_amount: "Total ordered amount"
    },
    recent_activities: {
      headers: {
        quotes: "Quotes",
        products: "Products",
        orders: "Orders",
        customers: "Customers",
        manufacturer_parts: "Manufacturer Parts",
        audit_history: "Audit History",
        boms: "BOMs",
        costEstimators: "Cost Estimators"
      },
      title: "Title",
      status: "Status",
      updated_at: "Last Updated",
      more: "More",
      account_name: "Name",
      account_number: "Account Number",
      product_name: "Product Name",
      product_type: "Product Type",
      display_name: "Display Name",
      specification: "Specification",
      audit_entity: "Entity",
      audit_event: "Action",
      audit_action_by: "Action By",
      created_at: "Date Created",
      bom_name: "Name",
      bom_type: "Bom Type",
      quantity: "Quantity"

    }
  },
  account: {
    search: "Search account",
    new: 'Load Accounts',
    search_placeholder: 'Enter company name to search...',
    attribution: "Attribution",
    list_form: {
      name: "Name",
      short_code: "Short code",
      short_name: "Short name",
      account_number: "Account number",
      crm_id: "CRM ID",
      updated_at: "Updated at",
      action: "Action",
      delete_tip: "Are you sure to delete this account?",
      load_account: "Load account",
      search_placeholder: "Enter the account name to query",
      attribution: "Attribution"
    },
    edit: {
      name: "Display Name/Branding Name",
      fullname: "Full name",
      report_name: "Report name",
      report_name_desc: "Same name will be grouped together in reports.",
      short_code: "Short code",
      short_name: 'Short name',
      customer_information: "Customer provided parts",
      add_customer_information: "Add customer provided part",
      account_number: "Account number",
      account_manager: "Account manager",
      company: "Company",
      country: "Country",
      category: "Category",
      preferred_currency: "Preferred currency",
      attribution_is_required: "Attribution is required.",
      country_is_required: "Country is required.",
      company_is_required: "Company is required.",
      category_is_required: "Category is required.",
      preferred_currency_is_required: "Currency is required.",
      account_recent_activities: {
        show_more_data: "Show more",
        show_less_data: "Show less",
        headers: {
          products: "Products",
          orders: "Orders",
          quotes: "Quotes"
        },
        products: {
          product_name: "Product Name",
          manufacturer_parts: "Manufacturer Parts"
        },
        order_and_quotes: {
          title: "Title",
          creation_date: "Creation Date",
          status: "Status"
        }
      }
    },
    customer_information_form: {
      part_number: 'PN',
      name: 'Name',
      specification: 'Specification',
      brand: 'Brand',
      mpn: 'MPN',
      stock: 'Stock',
      material_state: 'State（material）',
      customer_information_state: 'Status',
      action: 'Action',
      status_on: 'ON',
      status_off: 'OFF'
    },
    click_to_access_account_info_message: "Click to view customer information.",
    external_relationship: "External relationship"
  },
  notice: {
    error: "Error message",
    warning: "Warning message"
  },
  message: {
    success_on_saving: "Successfully saved!",
    failure_on_saving:
      "There is an error has occurred on saving, contact IT for help.",
    refresh_page_reload: "Refresh page if this takes too long to finish."
  },
  file_managed: {
    exceed_max_num_message: "You can only upload %1$s of files.",
    up_to_number_can_be_uploaded: "Up to %1$s files can be uploaded.",
    file_successfully_removed: "File has been removed successfully."
  },
  select_bom_file: {
    processing_bom_file: "Processing BOM file, please be patient.",
    unknown_error_on_reading_file:
      "An unknown error has occurred on reading BOM file, please check your BOM file or contact IT for help."
  },
  bom_hierarchy_nested_tree_editor: {
    heading: "Edit the item and adjust BOM's hierarchy by drag-and-drop",
    local_bom_file_rows_found: "Unsaved BOM hierarchy found",
    confirm_to_load_bom_file_from_local:
      "There is another BOM hierarchy edited without being saved, do you want to load it and continue editing?",
    local_bom_file_rows_found_modal_ok_text: "Load",
    local_bom_file_rows_found_modal_cancel_text:
      "Cancel and delete the unsaved one",
    error_panel: "Error panel",
    error_tip_1: "The following errors were found during the last save:",
    error_tip_2: "Press Save after modification to eliminate errors"
  },
  product: {
    info: {
      product_name: "Name",
      product_alias: "Short name",
      english_name: "English name",
      english_name_help: "English name will be used to external (customer) systems, such as Quickbooks.",
      product_code: "ERP product ID",
      product_type: "Type",
      product_model: "Model",
      file_type: "File type",
      file_description: "Description",
      upload_file: "Upload File",
      file_type_description_attributes_are_required:
        "File type and description is required.",
      category: "Category",
      unit_price: "Unit price",
      unit_cost: "Unit cost",
      margin: "Margin",
      currency: "Currency",
      lifecycle_status: "Status",
      manufacturer_part: "Manufacturer part",
      product_number: "Product number",
      product_status_active: "Active",
      product_status_discontinued: "Discontinued",
      product_type_product: "Product",
      product_type_service: "Service",
      customer: "Customer",
      webpagelink: "Webpage link"
    },
    tabs: {
      attachments: "Attachments",
      orders: "Orders",
      projects: "Projects",
      quotes: "Quotes",
      pcbs: "PCB",
      boms: "BOM"
    },
    plugins: {
      quote: {
        add_new_quote: "Add new quote",
        empty: "No quotes data.",
        table: {
          title: "Title",
          quantity: "Quantity",
          expected_delivery_date: "Expected delivery date",
          owner: "Owner",
          status: "Status",
          created: "Created",
          actions: "Actions"
        }
      },
      orders: {
        add_new_order: "Add new order",
        empty: "No orders data."
      },
      bom: {
        table: {
          title: "BOM",
          part_name: "Part",
          version: "Current version",
          note: "Latest note",
          actions: "Actions"
        },
        found_new_changes: "Found changes",
        search_placeholder: 'Please enter BOM name to search'
      },
      manufacturer_part: {
        has_no_bom_message: "No BOM found related.",
        add_new_part: "Add new part",
        remove_modal: {
          title: "Remove Technical Part",
          warning: "This manufacturer part will no longer be associated to this product.",
          confirm: "Do you want to proceed?",
          button_text: "Yes, Proceed"
        }
      }
    },
    remove_association_confirmation:
      "You are about to remove the association, click OK to confirm the removal.",
    associate_bom: "Associate a BOM",
    attachments: {
      description:
        "Assets of documents received or created needs to be managed.",
      img_title: "Image View"
    },
    search: "Search product",
    click_here_to_view_product: "Click here to see the product.",
    new_product: "New product",
    product_number: "Product number",
    product_name: "Product name",
    product_type: "Type",
    category: "Category",
    status: "Status",
    created_at: "Created at",
    enter_product_name: "Enter product name.",
    enter_product_number: "Enter product number.",
    enter_product_model: "Enter Product Model",
    product_type_product: "Product",
    product_type_service: "Service",
    product_status_active: "Active",
    product_status_discontinued: "Discontinued",
    customer: "Customer",
    reference_assembled_part_help_text: "Select a reference if there is a manufacturer part.",
    english_name_is_required: "English name is required (needed for Quickbooks)"
  },
  pcb: {
    list: {
      title: "PCB"
    },
    button: {
      new_pcb: "New PCB",
      quote_pcb: "Create quote of this pcb",
      save_pcb_spec: "Save PCB information"
    },
    form: {
      board_name: "Board name",
      chinese_name: "Board name (Chinese)",
      specification: "Specification",
      description: "Description",
      moderation: "Moderation",
      dimension: "Dimension",
      width: "Width",
      height: "Height",
      layers: "Layers",
      select: "Select",
      materials: "Materials",
      finished_thickness: "Finished thickness",
      legend_color: "Legend color",
      copper_weight: "Copper weight",
      min_trance_space_mil: "Min. trace/space(mil)",
      top_side_bottom_side: "Top side/bottom side",
      measurement_unit: "Measurement unit",
      different_designs: "Different design",
      pcb_standard: "PCB standard",
      solider_mask: "Solider mask",
      surface_finished: "Surface finished",
      min_hole_sizes: "Min. hole sizes",
      board_name_placeholder: "Such as LPCXpresso55S69 Circuit Board rev A1",
      description_placeholder:
        "Provide any information you think can describe the board...",
      impedance_test: {
        field_name: 'Impedance test',
        yes: 'Yes',
        no: 'No'
      }
    },
    image: "Image",
    edit: {
      title: "PCB information",
      specifications: "PCB Specifications"
    },
    new: {
      title: "Create PCB information"
    },
    search: "Search PCB"
  },
  mechanical: {
    list: {
      title: "Mechanical parts"
    },
    button: {
      new_mechanical: "New mechanical part"
    },
    form: {
      category: "Category",
      name: "Name",
      chinese_name: "Name (Chinese)",
      specification: "Specification",
      description: "Description",
      moderation: "Moderation",
      name_placeholder: "Such as, RS2 bottom",
      description_placeholder:
        "Provide any information you think can describe the part..."
    },
    image: "Image",
    edit: {
      title: "Mechanical part information"
    },
    new: {
      title: "Create mechanical part information"
    }
  },
  electronic: {
    button: {
      new_electronic_part: "New electronic part",
      octopart_add: "Add to Pangu"
    },
    octopart_search: {
      performan_mpn_search_info: 'Perform search on Octopart with MPN.'
    }
  },
  assembled: {
    list: {
      title: "PCBA, Semi-finished & Finished Parts"
    },
    button: {
      new_assembled: "New assembled part"
    },
    form: {
      category: "Category",
      name: "Name",
      chinese_name: "Name (Chinese)",
      specification: "Specification",
      description: "Description",
      moderation: "Moderation",
      name_placeholder: "Such as, RS2 semi-unfinished",
      description_placeholder:
        "Provide any information you think can describe the part..."
    },
    image: "Image",
    edit: {
      title: "Assembled part information"
    },
    new: {
      title: "Create assembled part information"
    }
  },
  material_line_items: {
    display_name: "Display name",
    net_qty: "Net qty",
    net_cost: "Net cost",
    price: "Price (non-taxed)",
    amount: "Amount",
    tax: "Tax",
    specification: "Specification",
    note: "Note",
    designator: "Designator",
    stock: "Stock",
    all_qty: "Qty",
    supplier_price: 'Supplier price',
    risk_amount: 'Risk cost'
  },
  quality: {
    scrap: {
      title: "Scrap",
      no_scrap_check: "Only show not set scrap",
      scrap_tip: "Scrap is set",
      history_model_title: "Scrap change histories",
      edit_model_title: "Scrap setting",
      edit_model_tip: "Modifying here will not affect the scrap setting of BOM",
      load_default_scrap_rate: "Load default scrap rate"
    },
    scrap_list: {
      "search_placeholder": "Search MPN, part name or part number."
    }
  },
  workflow: {
    state_badge: {
      pending: "Pending"
    },
    status_title: 'Status',
    status: {
      created: 'Created',
      pending_cost_submissions: 'Pending cost submissions',
      cost_submitted: 'Cost submitted',
      pending_cost_approval: 'Pending cost approval',
      pending_margin_submission: 'Pending margin submission',
      margin_review: 'Margin review',
      approved: 'Approved',
      closed: 'Closed'
    }
  },
  task: {
    no_tasks: "You have no tasks!",
    task_info: "Task information",
    closure_notice: "This task will be completed automatically on quote's closure.",
    go_to_quote_page: "Go to quote page."
  },
  people: {
    fullname_cn: "Fullname",
    gender: "Gender",
    department: "Department",
    email: "Email",
    country: "Country",
    erp_id: "ERP account ID",
    erp_people_id: "ERP people ID",
    new_people: "New people",
    chinese_name: "Chinese name",
    english_name: "English name",
    mobile: "Mobile",
    birthday: "Birthday",
    identities: "Identities",
    dingtalk_id: "DingTalk ID",
    uuid: "UUID",
    userid: "User ID"
  },
  nsf: {
    engineering: "Engineering",
    npi: "New Product Introduction (NPI)",
    productization: "Productization",
    s1_desc: "Prototyping for funtionality validation",
    s2_desc: "Prototyping for manufacturable validation",
    s3_desc: "New product introduction.",
    s4_desc: "Pilot run",
    s5_desc: "Volume production",
    s6_desc: "SCM"
  },
  process_order_category: {
    "1_label": "甲 (Jia)",
    "1_desc": "Usually it is an order in the S6 stage. At present, it generally refers to Emlid's non-accessory orders, Kenitic arm guards, and PiShop's PiKIV orders; it is a key order for the company's business and needs to be highly valued.",
    "2_label": "乙 (Yi)",
    "2_desc": "It is usually an order repeatedly placed by customers, and the product and business have a high degree of similarity, such as EA orders. Such orders need to consider standardization, informatization, and digital processing.",
    "3_label": "丙 (Bing)",
    "3_desc": "Orders with high potential value, high potential value includes orders that may have a loss in the current order but have a high return on reorders or orders that match the company's development strategy.",
    "4_label": "丁 (Ding)",
    "4_desc": "Usually it is a proofing order, requiring fast delivery, with the goal of completing the company's performance."
  },
  org: {
    accelerating_center: "Accelerating center",
    delivery_center: "Delivery center",
    trading: "Trading",
    dm: "Display module (DM)",
    other: "Other",
    company_category_a: "A",
    company_category_b: "B",
    company_category_c: "C",
    company_category_d: "D",
    preferred_currency: "Preferred currency",
    company_category_a_desc: "Industrial leading enterprise, single year contract amount greater than or equal to 10M RMB",
    company_category_b_desc: "Particular sector leading enterprise, single product contract amount greater than or equal to 2M RMB",
    company_category_c_desc: "New and has potentials (proposal).",
    company_category_d_desc: "Others (as is)",
    company_related_object: "Related objects"
  },
  error_notice: {
    4220201: 'Material exists, not able to add a duplicate component',
    4220601: 'Delete part number is not allowed due to some restriction.',
    4220602: 'Generate part number is not allowed due to some restriction.',
    4220603: 'Delete part is not allowed.',
    4220604: 'Duplicated MPN and Brand is found.',
    4220605: 'Missing part category.',
    4220606: 'Part category not found.',
    4220607: 'Customer provided part\'s number shall be matching with the rule: {PN}-{SHORT_CODE}.',
    4220608: 'Part number is missing.',
    4220502: 'The current version of BOM already exists in ERP, synchronization is not allowed',
    4220701: 'Missing required account name property.',
    4220702: 'Short code has already been taken.',
    1000702: 'Missing order number.',
    1000703: 'Order number duplicated.',
    1000608: 'The given part about to add to mutual substitute group has overlap with another.',
    1000801: 'Sorry, The part is already associated to {product_name}, you can not add a part to different product',
    9000101: 'Basecamp integration user, Robot with email of itas@nexpcb.com, shall be added to the project.'
  }
}
